
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class BrandAmbassadorSettingsGrid extends Serenity.EntityGrid<BrandAmbassadorSettingsRow, any> {
        protected getColumnsKey() { return BrandAmbassadorSettingsColumns.columnsKey; }
        protected getDialogType() { return BrandAmbassadorSettingsDialog; }
        protected getIdProperty() { return BrandAmbassadorSettingsRow.idProperty; }
        protected getInsertPermission() { return BrandAmbassadorSettingsRow.insertPermission; }
        protected getLocalTextPrefix() { return BrandAmbassadorSettingsRow.localTextPrefix; }
        protected getService() { return BrandAmbassadorSettingsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}